





import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Provide, Prop } from 'vue-property-decorator'
import {VForm} from '@/types';

export type ValueAccessor = (field: string) => any
export type ValueMutator = (payload: {field: string, value: any}) => void

/**
 * Formulario con capacidades de Vuex
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class Form extends Vue {
    public $refs: {
        form: VForm,
    }

    /**
     * Hace referencia la entidad del estado
     */
    @Prop({type: String, default: ''})
    public vuexState: string

    /**
     * Nombre de la mutación utilizada para actualizar los campos de la entidad
     */
    @Prop({type: String, default: ''})
    public mutation: string

    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Provee a todos los componentes descendientes de la función para mutar
     * la entidad
     */
    @Provide()
    get valueMutator (): ValueMutator | null {
        if (!this.mutation) {
            return null
        }

        return (payload: {field: string, value: any}) => {
            this.$store.commit(this.mutation, payload)
        }
    }

    /**
     * Provee a todos los componentes descendientes de la función para acceder
     * a un determinado valor de la entidad
     */
    @Provide()
    get valueAccessor (): ValueAccessor | null {
        if (!this.vuexState) {
            return null
        }

        return (field: string) => {
            return _.get(this.$store.state, `${this.vuexState}.${field}`, null)
        }
    }

    /**
     * Valida el formulario comprobando las reglas de cada input
     */
    public validate (): boolean {
        return this.$refs.form.validate()
    }

    public resetValidation () {
        return this.$refs.form.resetValidation()
    }

    /**
     * Actualiza un campo de la entidad actualmente administrada por el formulario
     *
     * @param field Nombre del campo a actualizar
     * @param value Nuevo valor
     */
    public update (field: string, value: any) {
        // tslint:disable-next-line:no-unused-expression
        this.valueMutator && this.valueMutator({field, value})
    }
}
